export default __webpack_public_path__ + "static/media/Website-Filings.54ef020d.pdf";